import http from '@/utils/http'

const TICKET_BASE_URL = process.env.VUE_APP_TICKET_BASE_API || '/support/tickets'

export const ticketApi = {
  getTickets(params) {
    return http.get(TICKET_BASE_URL, { params })
  },

  createTicket(payload) {
    return http.post(TICKET_BASE_URL, payload)
  },

  getTicket(id) {
    return http.get(`${TICKET_BASE_URL}/${encodeURIComponent(id)}`)
  },

  addMessage(id, payload) {
    return http.post(`${TICKET_BASE_URL}/${encodeURIComponent(id)}/messages`, payload)
  },

  closeTicket(id) {
    return http.patch(`${TICKET_BASE_URL}/${encodeURIComponent(id)}/close`)
  }
}
